import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SettingsService } from '../settings.service';
import { ATLAS_REQUEST_HEADER } from '@secca/shared/interceptor/atlas-unauthorized.http.interceptor';

@Injectable({
  providedIn: 'root'
})
export class AtlasApiService {
  constructor(
    private settingsService: SettingsService,
    private keycloakService: KeycloakService
  ) {}

  buildUrl(path: string, baseUrl = this.settingsService.getAtlasApiServiceEndpoint()): string {
    const base = baseUrl.replace(/\/+$/, '');
    return `${base}${path}`;
  }

  withAtlasAuth<T>(requestFactory: (headers: HttpHeaders) => Observable<T>): Observable<T> {
    return from(this.keycloakService.getToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
          [ATLAS_REQUEST_HEADER]: 'true'
        });
        return requestFactory(headers);
      })
    );
  }
}
